import { AutoNetworkOffset } from './recordm.auto.network.js';
import { AutoRefField } from './recordm.auto.ref.js';
import { AutoTextJoin } from './recordm.auto.text.js';

var _functions = new Map();
_functions.set("AutoTextJoin", AutoTextJoin);
_functions.set("AutoRefField", AutoRefField);
_functions.set("AutoNetworkOffset", AutoNetworkOffset);

var Auto = {}

Auto.getFunction = function(internal, auto) {
   return _functions.get(auto.type)(internal, auto.args);
};

export default Auto;
